<div class="content__page" [ngClass]="{
    'bg_dark': ['home', 'characteristics', 'tickets-saved', 'under-construction', 'login', 'register', 'forgot-password'].indexOf(router.url.split('/')[1]) > -1 || router.url.split('/')[1].indexOf('search') > - 1,
    'bg_light': ['search'].indexOf(router.url.split('/')[1]) > -1,
  }">
  <router-outlet></router-outlet>
</div>
